import { combineReducers } from 'redux';
import appsReducer from './apps/reducers';
import ancillaryReducer from './ancillary/reducers';
import uarReducer from './uar/reducers';
import requestFlowReducer from './requestFlow/reducers';
import workQueueReducer from './workQueue/reducers';
import workQueueAdminTable from './adminTable/reducers';
import adminSearchTable from './adminSearch/reducers';
import sideMenuReducer from './sideMenu/reducers';
import pendingApprovalsReducer from './pendingApprovals/reducers';
import { helpSlice } from './helpSlice';

const rootReducer = combineReducers({
	apps: appsReducer,
	ancillary: ancillaryReducer,
	uar: uarReducer,
	requestFlow: requestFlowReducer,
	workQueue: workQueueReducer,
	workQueueAdminTable: workQueueAdminTable,
	adminSearchTable: adminSearchTable,
	sideMenu: sideMenuReducer,
	pendingApprovals: pendingApprovalsReducer,
	help: helpSlice.reducer,
});

export default rootReducer;
